/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ActivityItem
 */
export interface ActivityItem {
    /**
     * 
     * @type {string}
     * @memberof ActivityItem
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityItem
     */
    description: string;
    /**
     * 
     * @type {Date}
     * @memberof ActivityItem
     */
    createdAtUtc: Date;
}

/**
 * Check if a given object implements the ActivityItem interface.
 */
export function instanceOfActivityItem(value: object): value is ActivityItem {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('createdAtUtc' in value) || value['createdAtUtc'] === undefined) return false;
    return true;
}

export function ActivityItemFromJSON(json: any): ActivityItem {
    return ActivityItemFromJSONTyped(json, false);
}

export function ActivityItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActivityItem {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'description': json['description'],
        'createdAtUtc': (new Date(json['createdAtUtc'])),
    };
}

export function ActivityItemToJSON(json: any): ActivityItem {
    return ActivityItemToJSONTyped(json, false);
}

export function ActivityItemToJSONTyped(value?: ActivityItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'description': value['description'],
        'createdAtUtc': value['createdAtUtc'].toISOString(),
    };
}

